import { useSelector } from 'react-redux';
import { useCallback, useEffect, useRef } from 'react';

import { useActions, useFetching } from '@mssgme/hooks';
import { getConversation, getConversationMessages } from '@mssgme/store';

export default function useMessageList(contactId) {
    const refHate = useRef();
    const actions = useActions();
    const { conversation, items, next, hasNext } = useSelector((state) => {
        const conversation = getConversation(state, contactId);
        const messages = getConversationMessages(state, contactId);

        return {
            conversation,
            ...(messages || { items: [], hasNext: true, next: null }),
        };
    });
    const { pending, run } = useFetching((query) => actions.api.conversations.messages({ contactId, query }));

    useEffect(() => void run(), [contactId]);

    const onScroll = useCallback(
        async ({ target }) => {
            if (refHate.current) {
                return;
            }

            if (target.scrollTop <= 200) {
                refHate.current = true;

                try {
                    await run({ next });
                } finally {
                    refHate.current = false;
                }
            }
        },
        [contactId, next]
    );

    return {
        items,
        conversation,
        hasMore: hasNext,
        onScroll: hasNext && !pending ? onScroll : undefined,
    };
}
